package se.mittpass.shared.repository

import io.ktor.client.*
import io.ktor.client.call.body
import io.ktor.client.request.*
import se.mittpass.shared.api.*

class ExpenseRepository(private val httpClient: HttpClient) {
    suspend fun getExpenses(workplaceId: Long): Result<List<ExpenseDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/expenses").body()
    }
    suspend fun createExpense(workplaceId: Long, req: CreateExpenseRequest): Result<Unit> = runCatching {
        httpClient.post("workplaces/$workplaceId/expenses") { setBody(req) }
    }
    suspend fun reviewExpense(expenseId: Long, req: ReviewExpenseRequest): Result<Unit> = runCatching {
        httpClient.put("expenses/$expenseId/review") { setBody(req) }
    }
    suspend fun deleteExpense(expenseId: Long): Result<Unit> = runCatching {
        httpClient.delete("expenses/$expenseId")
    }
}
